import React from 'react';
import styled from 'styled-components';
import { ChevronIcon, colors, H2 } from '@commonsku/styles';
import { skuFont } from '../../helpers/styles';
import { BreadcrumbItem, CategoryBreadcrumbProps } from './types';

const HOME_ITEM: BreadcrumbItem = {
  label: 'Connected+ Products',
  value: null,
};

const BreadcrumbContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 5px;
  padding: 0;
  margin-bottom: 1rem;
`;

const BreadcrumbCurrent = styled(H2)`
  &&& {
    margin-bottom: 0;
    font-family: ${skuFont};
  }
`;

const BreadcrumbLink = styled(H2)`
  &&& {
    color: ${colors.primary1['65']};
    margin-bottom: 0;
    cursor: pointer;
    font-family: ${skuFont};
  }
`;

const CategoryBreadcrumb: React.FC<CategoryBreadcrumbProps> = ({
  items,
  onRefine,
}) => {
  const breadcrumbItems = items && items.length > 0 ? [HOME_ITEM, ...items] : [];

  return (
    <BreadcrumbContainer>
      {breadcrumbItems.map((item, index) => {
        const isLast = index === breadcrumbItems.length - 1;

        return (
          <React.Fragment key={item.value ?? 'home'}>
            {isLast ? (
              <BreadcrumbCurrent>{item.label}</BreadcrumbCurrent>
            ) : (
              <BreadcrumbLink
                onClick={(e: React.MouseEvent) => {
                  e.preventDefault();
                  onRefine(item.value);
                }}
              >
                {item.label}
              </BreadcrumbLink>
            )}
            {!isLast && <ChevronIcon direction="right" size='large' color={colors.neutrals['60']} />}
          </React.Fragment>
        );
      })}
    </BreadcrumbContainer>
  );
};

export default CategoryBreadcrumb;
